const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfArchitecture extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfArchitecture,
            "Each civilization scores 1 culture per level of each of its urban buildings.",
            {}
        )
    }
}

module.exports = ImpactOfArchitecture;